import { SVGComponentProps } from "./utils/Types"

const SendIcon = ({ width = 30, height = 30, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            height={width}
            width={height}
            viewBox="0 0 24 24">
            <path
                d="M20 4L3 11L10 14M20 4L13 21L10 14M20 4L10 14"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>

    )
}

export default SendIcon
